import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.css";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./components/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <App />
  </Router>,
);
